require('./mortgageRequestTPVIframe.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

class MortgageRequestTPVIframe extends React.Component {
    static constants = {
        FRAME_BORDER: "0",
        SCROLLING: "no",
        TITLE: "título",
    }

    generateURL() {
        const {
            immFlagBasedFeatures,
            MERCHANT_AMOUNT,
            MERCHANT_CURRENCY,
            MERCHANT_MERCHANTCODE,
            MERCHANT_ORDER,
            MERCHANT_TERMINAL,
            OPERATION,
            SECURE,
            signature,
        } = this.props;
        const _3DSECURE = !!SECURE ? `&3DSECURE=${SECURE}` : '';
        const tpvURL = immFlagBasedFeatures.get('web-paytpv-url');

        return (
            `${tpvURL}?MERCHANT_MERCHANTCODE=${MERCHANT_MERCHANTCODE}&MERCHANT_TERMINAL=${MERCHANT_TERMINAL}&OPERATION=${OPERATION}&MERCHANT_MERCHANTSIGNATURE=${signature}&MERCHANT_ORDER=${MERCHANT_ORDER}&MERCHANT_AMOUNT=${MERCHANT_AMOUNT}&MERCHANT_CURRENCY=${MERCHANT_CURRENCY}${_3DSECURE}`
        );
    }

    render() {
        return (
            <div className="mortgage-request-tpv-iframe">
                <iframe
                    src={this.generateURL()}
                    title={MortgageRequestTPVIframe.constants.TITLE}
                    frameBorder={MortgageRequestTPVIframe.constants.FRAME_BORDER}
                    scrolling={MortgageRequestTPVIframe.constants.SCROLLING}
                    className="mortgage-request-tpv-iframe__iframe"
                />
            </div>
        );
    }
}

MortgageRequestTPVIframe.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    MERCHANT_AMOUNT: PropTypes.number.isRequired,
    MERCHANT_CURRENCY: PropTypes.string.isRequired,
    MERCHANT_MERCHANTCODE: PropTypes.string.isRequired,
    MERCHANT_ORDER: PropTypes.string.isRequired,
    MERCHANT_TERMINAL: PropTypes.string.isRequired,
    OPERATION: PropTypes.string.isRequired,
    SECURE: PropTypes.string,
    signature: PropTypes.string.isRequired,
};

module.exports = MortgageRequestTPVIframe;
